var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_c('Toolbar3'),_c('div',{staticClass:"d-flex"},[_c('Feature6')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }